import React from 'react';

/**
 * Placeholders de carga con brillo (shimmer). Mantienen la MISMA estructura que
 * el contenido final para que no haya salto de layout cuando llegan los datos.
 */
export const Skel = ({ w = '100%', h = 12, r = 6, className = '', style }) => (
  <div
    className={['a2-skel', className].filter(Boolean).join(' ')}
    style={{ width: w, height: h, borderRadius: r, ...style }}
  />
);

/** Rejilla de tarjetas-KPI en carga. */
export const SkeletonKpis = ({ count = 4 }) => (
  <div className="a2-grid-kpi" style={{ marginBottom: 16 }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="a2-card" style={{ padding: '18px 20px' }}>
        <Skel w={38} h={38} r={11} style={{ marginBottom: 14 }} />
        <Skel w="62%" h={24} r={7} style={{ marginBottom: 9 }} />
        <Skel w="42%" h={12} />
      </div>
    ))}
  </div>
);

/** Tarjeta con filas (tabla/listado) en carga. */
export const SkeletonRows = ({ rows = 5, title = true }) => (
  <div className="a2-card a2-card-pad">
    {title ? <Skel w={210} h={18} style={{ marginBottom: 22 }} /> : null}
    {Array.from({ length: rows }).map((_, i) => (
      <div
        key={i}
        style={{
          display: 'flex', alignItems: 'center', gap: 14, padding: '12px 0',
          borderTop: '1px solid var(--line)',
        }}
      >
        <Skel w={40} h={40} r={10} style={{ flexShrink: 0 }} />
        <div style={{ flex: 1 }}>
          <Skel w="38%" h={13} style={{ marginBottom: 8 }} />
          <Skel w="24%" h={10} r={5} />
        </div>
        <Skel w={76} h={13} />
      </div>
    ))}
  </div>
);

/** Rejilla de tarjetas (recibos, planes…) en carga. */
export const SkeletonCards = ({ count = 6, height = 210, min = 240 }) => (
  <div style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fill,minmax(${min}px,1fr))`, gap: 12 }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="a2-card" style={{ padding: 18 }}>
        <Skel w="55%" h={16} style={{ marginBottom: 14 }} />
        <Skel w="100%" h={height - 96} r={10} style={{ marginBottom: 14 }} />
        <Skel w="100%" h={38} r={10} />
      </div>
    ))}
  </div>
);

/** Skeleton de página completa. Con `kpis={0}` omite la fila de tarjetas. */
export const SkeletonPage = ({ kpis = 4, rows = 5 }) => (
  <div className="a2-anim-fadein">
    {kpis > 0 ? <SkeletonKpis count={kpis} /> : null}
    <SkeletonRows rows={rows} />
  </div>
);

export default Skel;
